import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import HeadlineBanner from "../components/v2/headline-banner";
import MediaSlider from "../components/v2/media-slider";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";

// Hooks
import useEvoHotelPageImages from "../hooks/useEvoHotelPageImages";
import ArrowLink from "../components/global/arrow-link";
import ImageGridBanner from "../components/v2/image-grid-banner";

const EvoHotel = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="evo Hotel" />
      <SimpleHero
        contentData={
          {
            pre_title: "evo",
            title: "Hotel",
          }
        }
        imageData={useEvoHotelPageImages({name: "evo-hotel-1"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="Exactly Where You’re"
        title="Meant To Be"
      />
      <FiftyFiftyHorizontal
        imageData={useEvoHotelPageImages({name: "evo-hotel-2"})}
      >
        <p>evo Hotel has been meticulously designed to provide a one-of-a-kind lodging experience for our community. If you’re coming to Salt Lake for the skiing, biking, climbing, hiking - or any other outdoor activity - consider it your launchpad for adventure. Just about every detail of evo Hotel pays homage to Salt Lake City and the outdoor recreation that surrounds it. In addition, each room includes the work of a different Utah artist.</p>
        <p>
          <ArrowLink
            isExternalLink={true}
            to="https://www.evohotel.com/"
            text="Book Now"
            theme="dark-body"
          />
        </p>
      </FiftyFiftyHorizontal>

      <ImageGridBanner
        className="spacing spacing--spacing-1"
        imageData={useEvoHotelPageImages({name: "evo-hotel-6"})}
      >
        <p>
          <strong>Wasatch Room</strong>
          <br />
          <span>Feature private patios with sweeping views of the Wasatch Range.</span>
        </p>
      </ImageGridBanner>

      <ImageGridBanner
        className="spacing spacing--general"
        imageData={useEvoHotelPageImages({name: "evo-hotel-7"})}
      >
        <p>
          <strong>Rafter Rooms</strong>
          <br />
          <span>Provide cozy sanctuary up in our building’s vintage trusses.</span>
        </p>
      </ImageGridBanner>

      <ImageGridBanner
        className="spacing spacing--general"
        imageData={useEvoHotelPageImages({name: "evo-hotel-8"})}
      >
        <p>
          <strong>Boulder Rooms</strong>
          <br />
          <span>Located above the bouldering gym, these rooms offer the ambience of a retro lodge.</span>
        </p>
      </ImageGridBanner>

      <ImageGridBanner
        className="spacing spacing--general"
        imageData={useEvoHotelPageImages({name: "evo-hotel-9"})}
      >
        <p>
          <strong>Bunk Rooms</strong>
          <br />
          <span>Spacious and functional rooms for you and your crew.</span>
        </p>
      </ImageGridBanner>

      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useEvoHotelPageImages({name: "evo-hotel-3"}),
            description: "",
          },
        ]}
      />
      <GetUpdates
        className="spacing spacing--general"
      />
      <DetailsFooter
        imageData={useEvoHotelPageImages({name: "evo-hotel-4"})}
        imageDataHover={useEvoHotelPageImages({name: "evo-hotel-5"})}
        linkData={{
          title: "Read Story",
          project_url: "/evo-salt-lake/",
        }}
        pre_title="Up Next"
        title="evo Salt Lake"
      />
    </Layout>
  )
}

export default EvoHotel
